<template>
    <aside :class="'reg-temp-v2-sidebar ' + (vg_hamMenuActive ? 'active' : '')">
        <div class="site-logo">
            <img src="@/assets/images/dewhot_logo.png" alt="dewhot logo" />
            <a href="" class="mobile-close-ham-menu" @click.prevent="va_setHamMenu(false)"><i class="fas fa-times"></i></a>
        </div>
        <div class="user-panel">
            <div class="user-icon">
                <img v-if="vg_user.avatar" :src="vg_user.avatar" alt="user" />
                <img v-else src="@/assets/images/user.png" alt="user" />
            </div>
            <div class="user-name">
                <p class="uname">{{ vg_loggedInUserName }}</p>
                <p>
                    <small>{{ vg_user.email }}</small>
                    <small class="text-capitalize">{{ vg_user.role }}</small>
                    <router-link :to="{name: 'EditProfile'}" class="edit-profile color-blue"> Edit</router-link>
                </p>
            </div>
        </div>
        <div class="aside-nav">
            <ul>
                <li>
                    <router-link :to="{name: 'CustomerDashboard'}"> Dashboard </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'CustomerRegisteredProducts'}"> Registered Products </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'CustomerRegisteredProductsWarranties'}">Warranty Claims</router-link>
                </li>

                <li>
                    <router-link :to="{name: 'CustomerRegisteredProductsRepairs'}"> Repairs </router-link>
                </li>

                <li>
                    <a href="#" @click.prevent="signOut()"> Logout </a>
                </li>
            </ul>
        </div>
    </aside>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            vg_loggedInUserName: 'auth/username',
            vg_user: 'auth/user',
            vg_hamMenuActive: 'menu/active'
        })
    },

    watch: {
        // now for mobile on lcik menu the bar not getting close
        $route() {
            this.va_setHamMenu(false); // close on route change
        }
    },

    methods: {
        async signOut() {
            await this.va_logout();
            this.spinner(true);
            this.$toasted.global.success({
                message: 'Logging out, please wait...'
            });

            setTimeout(() => {
                window.location.href = '/';
            }, 1000);
        },

        ...mapActions({
            va_logout: 'clearAppData',
            va_setHamMenu: 'menu/setMenu'
        })
    }
};
</script>
